import React, { useEffect, useState } from 'react';
import { inventoryAPI } from '@/lib/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { ListX, Plus, X } from 'lucide-react';
import { toast } from 'sonner';

export const RejectionReasonsCard = () => {
  const [reasons, setReasons] = useState([]);
  const [name, setName] = useState('');

  const load = () => inventoryAPI.rejectionReasons().then(r => setReasons(r.data?.reasons || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    try {
      await inventoryAPI.addRejectionReason(name.trim());
      toast.success('Reason added');
      setName('');
      load();
    } catch (err) { toast.error(err.response?.data?.detail || 'Could not add the reason'); }
  };
  const remove = async (id) => {
    if (!window.confirm('Remove this reason?')) return;
    try { await inventoryAPI.deleteRejectionReason(id); toast.success('Reason removed'); load(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Could not remove the reason'); }
  };

  return (
    <Card data-testid="rejection-reasons-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2"><ListX className="w-5 h-5 text-red-600" /> Rejection Reasons</CardTitle>
        <CardDescription>Reasons offered when scrap / rejection is booked at route card closure or in MRB.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex flex-wrap gap-2">
          {reasons.map(r => (
            <Badge key={r.id} variant="outline" className="gap-1" data-testid={`reason-chip-${r.name}`}>
              {r.name}
              <button onClick={() => remove(r.id)} aria-label={`remove ${r.name}`} data-testid={`reason-remove-${r.name}`}>
                <X className="w-3 h-3" /></button>
            </Badge>
          ))}
        </div>
        <div className="flex gap-2 max-w-sm">
          <Input value={name} onChange={e => setName(e.target.value)} placeholder="New reason" className="h-8 text-xs"
            onKeyDown={e => e.key === 'Enter' && name.trim() && add()} data-testid="reason-new-input" />
          <Button size="sm" onClick={add} disabled={!name.trim()} data-testid="reason-add-btn"><Plus className="w-3.5 h-3.5 mr-1" /> Add</Button>
        </div>
      </CardContent>
    </Card>
  );
};
